import { Component, EventEmitter, OnDestroy, OnInit, Output, Renderer2, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { InputType } from 'src/app/models/enums';
import { LiteralService, UtilsService } from 'src/app/services';
import { images } from 'src/images';
import moment from 'moment';
import { deserializeAvailabilitiesFilters } from 'src/app/filters';

@Component({
  selector: 'app-availability-filter',
  templateUrl: './availability-filter.component.html',
  styleUrl: './availability-filter.component.scss',
  standalone: false
})
export class AvailabilityFilterComponent implements OnInit, OnDestroy {

  readonly componentOpen = input<string>();

  @Output() filter = new EventEmitter();
  @Output() closeFilter = new EventEmitter();

  // public date: Date;
  public fromDate: any | undefined;
  public toDate: any | undefined;
  public startTime: string | undefined;
  public endTime: string | undefined;
  public status: any[] = [];
  public bookings: any[] = [];

  public images = images;
  public moment = moment;

  public InputType = InputType;

  private queryParamsSub?: Subscription;

  constructor(
    renderer: Renderer2,
    public literalService: LiteralService,
    private utilsService: UtilsService,
    private activatedRoute: ActivatedRoute,
  ) {
     renderer.listen('window', 'click', (e: Event) => {
      const modal = document.getElementById('filterContainer')!;
      const componentOpen = document.getElementById(this.componentOpen()!)!;
      const close = utilsService.closeCustomModals(e, modal, componentOpen);
      if (close) {
        // if (this.select && this.select.nativeElement) this.select.nativeElement.checked = false;
        this.closeFilter.emit();
      }
    });

    this.status.push({value: 'Ongoing', checked: false });
    this.status.push({value: 'Ready', checked: false });
    this.status.push({value: 'Open', checked: false });

    this.bookings.push({value: 'with', checked: false });
    this.bookings.push({value: 'without', checked: false });
  }

  ngOnInit(): void {
    this.applyFromUrl();
    this.queryParamsSub = this.activatedRoute.queryParamMap.subscribe(() => this.applyFromUrl());
  }

  ngOnDestroy(): void {
    this.queryParamsSub?.unsubscribe();
  }

  private applyFromUrl(): void {
    const filters = deserializeAvailabilitiesFilters(this.activatedRoute.snapshot.queryParamMap);
    const selectedStatusLower = filters.selectedStatus.map(s => String(s).toLowerCase());
    this.status.forEach((status) => {
      status.checked = selectedStatusLower.includes(String(status.value).toLowerCase());
    });
    // Two checkboxes: with / without (mutually exclusive in the UI)
    this.bookings[0].checked = filters.bookings === true;
    this.bookings[1].checked = filters.bookings === false;
    this.fromDate = filters.fromDate;
    this.toDate = filters.toDate;
    this.startTime = filters.startTime;
    this.endTime = filters.endTime;
  }

  changeDate(event: any, type: 'from' | 'to') {
    if (type == 'from') this.fromDate = moment(event.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
    if (type == 'to') this.toDate = moment(event.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
  }

  changeTime(event: Event, type: 'start' | 'end') {
    const input = event.target as HTMLInputElement;
    const timeValue = input.value;
    
    if (type === 'start') {
      this.startTime = timeValue;
    } else {
      this.endTime = timeValue;
    }
  }

  selectAll(event: any) {
    this.status.map((status: any) => (status.checked = event.currentTarget.checked));
    this.bookings.map((type: any) => (type.checked = event.currentTarget.checked));
  };

  clearSelection() {
    this.status.map((status: any) => (status.checked = false));
    this.bookings.map((type: any) => (type.checked = false));
    this.fromDate = undefined;
    this.toDate = undefined;
    this.startTime = undefined;
    this.endTime = undefined;
  };

  onSubmit() {
    let bookings = undefined;
    if (this.bookings[0].checked === true && this.bookings[1].checked === false) {
      bookings = true;
    } else if (this.bookings[0].checked === false && this.bookings[1].checked === true) {
      bookings = false;
    }

    const selectedStatus: any[] = [];
    this.status.forEach((status: any) => {
      if (status.checked) selectedStatus.push(status.value); 
    });

    const fromDate = this.fromDate;
    const toDate = this.toDate;
    const startTime = this.startTime;
    const endTime = this.endTime;

    this.filter.emit({selectedStatus, bookings, fromDate, toDate, startTime, endTime});
  }
}
